import { WalletAddress } from '@btcdirect/stores';
import { InjectionKey } from 'vue';

export const enum DispatchEvents {
    CONFIRMED = 'btcdirect-embeddable-fiat-to-coin-order-confirmed',
    COIN_TO_FIAT_TRANSACTION_REQUESTED = 'btcdirect-embeddable-coin-to-fiat-order-requested',
    IDENTIFIED = 'btcdirect-embeddable-user-identified',
    REGISTRATION_COMPLETED = 'btcdirect-embeddable-registration-completed',
    REGISTRATION_STARTED = 'btcdirect-embeddable-registration-started',
    SIGNED_IN = 'btcdirect-embeddable-user-signed-in',
    SIGNED_OUT = 'btcdirect-embeddable-user-signed-out',
    WALLET_ADDRESS_CONFIRMATION_REQUESTED = 'btcdirect-embeddable-wallet-address-confirmation-requested'
}

export interface DispatchEventDetails {
    [key: string]: string | number | null;
}

/**
 * Options that can be provided during method calls.
 */
export interface MethodParameters extends Record<string, string | any> {
    address?: string;
    addresses?: WalletAddress | WalletAddress[];
    amount?: number;
    cancel?: number;
    crypto?: string;
    fiat?: string;
    id?: number;
    identifier?: string;
    include?: boolean;
    locale?: string;
    method?: string;
    name?: string;
    orderId?: number;
    slug?: string;
    startInOverview?: boolean;
    transactionId?: string;
    type?: string;

    // Offer parameters
    partner?: string;
    fiatCurrency?: string;
    fiatAmount?: number;
    cryptoCurrency?: string;
    cryptoAmount?: number;
    paymentMethod?: string;
    walletAddress?: string;
    signature?: string;
    walletAddressTag?: string;
    returnUrl?: string;
    callbackUrl?: string;
    partnerOrderIdentifier?: string;
    expiryDateTime?: string;
    fixedAmount?: boolean;
    fixedFiatCurrency?: boolean;
    fixedCryptoCurrency?: boolean;
    fixedPaymentMethod?: boolean;
    showWalletAddress?: boolean;

    // UCO user token authentication
    userToken?: string;
    userUuid?: string;

    enableAttemptDirectConfirm?: boolean;
}

/**
 * Converted MethodParameters for internal use
 * TODO: What is used after introducing stores?
 */
export interface InstanceParameters {
    walletAddresses?: WalletAddress[];
    confirmedWalletAddress?: string;
    walletAddressForVerification?: WalletAddress;
    selectedWalletAddress?: string;
    callbackUrl?: string;
    cancelOrder?: number;
    cryptoCurrency?: string;
    fiatCurrency?: string;
    includeDca?: boolean;
    locale?: string;
    userIdentifier?: string;
    orderId?: number;
    quoteId?: string;
    transactionId?: string;
    dcaStartInOverview?: boolean;
}

/**
 * Wallet address structure as provided by external parties
 * TODO: Deprecate the id param and make it identifier in order to use the new WalletAddress
 * TODO: Deprecate the string version of destinationTag
 */
export interface ExternalWalletAddress extends Omit<WalletAddress, 'destinationTag'> {
    id?: string;
    destinationTag?: string | number;
}

/**
 * Order status notification
 */
export interface OrderState {
    id: string;
    status: string;
    dismissed: boolean;
}

export interface OrderConfirmation {
    fiatCurrency: string;
    fiatAmount: number;
    orderId: string;
}

export interface TransactionRequest {
    currency: string;
    amount: number;
    walletAddress: string;
    destinationTag: number;
    orderId: number;
    userWalletAddress: string;
    userWalletIdentifier: string;
}

/**
 * Symbols for the Vue provide function to enable passing data from loader calls to the embeddable
 *
 * @see https://v3.vuejs.org/guide/component-provide-inject.html
 */
export const MethodCallParametersSymbol: InjectionKey<string> = Symbol('MethodCallParametersSymbol');
